module.exports = __webpack_public_path__ + "static/media/electrificacion motriz comercial.jpg.1ebc6280.png";